(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pointOnCubic(t, p0, p1, p2, p3) {
    var u = 1 - t;
    var tt = t * t;
    var uu = u * u;
    var uuu = uu * u;
    var ttt = tt * t;
    return {
      x: uuu * p0.x + 3 * uu * t * p1.x + 3 * u * tt * p2.x + ttt * p3.x,
      y: uuu * p0.y + 3 * uu * t * p1.y + 3 * u * tt * p2.y + ttt * p3.y
    };
  }

  function tangentOnCubic(t, p0, p1, p2, p3) {
    var u = 1 - t;
    return {
      x: 3 * u * u * (p1.x - p0.x) + 6 * u * t * (p2.x - p1.x) + 3 * t * t * (p3.x - p2.x),
      y: 3 * u * u * (p1.y - p0.y) + 6 * u * t * (p2.y - p1.y) + 3 * t * t * (p3.y - p2.y)
    };
  }

  /* Matches SVG path: M-40 160 C 180 40, 360 200, 560 110 S 920 40, 1240 130 */
  var SEGMENTS = [
    {
      p0: { x: -40, y: 160 },
      p1: { x: 180, y: 40 },
      p2: { x: 360, y: 200 },
      p3: { x: 560, y: 110 }
    },
    {
      p0: { x: 560, y: 110 },
      p1: { x: 760, y: 20 },
      p2: { x: 920, y: 40 },
      p3: { x: 1240, y: 130 }
    }
  ];

  function samplePath(t) {
    var clamped = Math.max(0, Math.min(0.9999, t));
    var idx = clamped < 0.5 ? 0 : 1;
    var local = idx === 0 ? clamped * 2 : (clamped - 0.5) * 2;
    var seg = SEGMENTS[idx];
    var pos = pointOnCubic(local, seg.p0, seg.p1, seg.p2, seg.p3);
    var tan = tangentOnCubic(local, seg.p0, seg.p1, seg.p2, seg.p3);
    return {
      x: pos.x,
      y: pos.y,
      angle: (Math.atan2(tan.y, tan.x) * 180) / Math.PI
    };
  }

  function animatePlane(plane) {
    if (!plane || REDUCE.matches) return function () {};

    var duration = 9000;
    var pause = 3200;
    var start = null;
    var running = true;
    var waiting = false;

    function tick(now) {
      if (!running) return;

      if (waiting) {
        requestAnimationFrame(tick);
        return;
      }

      if (start === null) start = now;
      var t = (now - start) / duration;

      if (t >= 1) {
        plane.setAttribute('opacity', '0');
        waiting = true;
        window.setTimeout(function () {
          if (!running) return;
          waiting = false;
          start = null;
        }, pause);
        requestAnimationFrame(tick);
        return;
      }

      var sample = samplePath(t);
      var opacity = t < 0.1 ? t / 0.1 : t > 0.88 ? (1 - t) / 0.12 : 1;
      plane.setAttribute(
        'transform',
        'translate(' + sample.x.toFixed(2) + ' ' + sample.y.toFixed(2) + ') rotate(' + sample.angle.toFixed(2) + ')'
      );
      plane.setAttribute('opacity', String(Math.max(0, Math.min(1, opacity)).toFixed(3)));
      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);

    return function stop() {
      running = false;
    };
  }

  function enhanceFooter(root) {
    if (!root || root.dataset.n1LuxReady === 'true') return;
    root.dataset.n1LuxReady = 'true';

    var plane = root.querySelector('.n1-lux-footer__plane');
    if (REDUCE.matches && plane) {
      plane.style.display = 'none';
      return;
    }

    var stop = animatePlane(plane);

    root._n1LuxDestroy = function () {
      if (typeof stop === 'function') stop();
    };
  }

  function init() {
    document.querySelectorAll('[data-n1-lux-footer]').forEach(enhanceFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var footer = section.querySelector('[data-n1-lux-footer]');
    if (!footer && section.matches && section.matches('[data-n1-lux-footer]')) footer = section;
    if (footer) {
      footer.dataset.n1LuxReady = '';
      enhanceFooter(footer);
    }
  });
})();
